import { EXPERIENCE_ANY_DATE } from 'constants/experience'
import GeoContext from 'contexts/geoContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { getExperienceTimesKey } from 'lib/experiences/experienceUtils'
import { useContext } from 'react'

type TimeParams = {
  date?: string
  redemptionLocationId?: string
  pickupPointId?: string
  isBuyNowBookLater?: boolean
  isGift?: boolean
  ticketModeKey?: string
}

const defaultState: App.ApiCallState<{ slots?: Array<App.ExperienceAvailabilityTimeSlot> }> = { fetching: false }

function useExperienceAvailableTimes(experience: App.ExperienceOffer | undefined, params: TimeParams): App.ApiCallState<{ slots?: Array<App.ExperienceAvailabilityTimeSlot> }> {
  const { redemptionLocationId, isBuyNowBookLater, isGift, date, pickupPointId } = params

  const experienceTimes = useAppSelector(state => experience ? state.experience.experienceTimes[experience.id] : undefined)
  const { currentCurrency: currency } = useContext(GeoContext)

  if (!experience) {
    return defaultState
  }

  const key = getExperienceTimesKey(experience.id, (isBuyNowBookLater || isGift) ? EXPERIENCE_ANY_DATE : date, {
    pickupPointId: experience.pickupOptional ? undefined : pickupPointId,
    redemptionLocationId,
    isBuyNowBookLater,
    isGift,
    currency,
    ticketMode: params.ticketModeKey,
  })

  return experienceTimes?.[key] ?? defaultState
}

export default useExperienceAvailableTimes
